import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { useData } from "../../hooks/useData";
import Icon from "../Icon";
import TiltCard from "../ui-custom/TiltCard";
import { Reveal } from "../ui-custom/Reveal";
import ServiceModal from "./ServiceModal";

// Grid of premium animated service cards. Optional filtering + limit.
export default function ServicesGrid({ limit, withFilter = false }) {
  const { data } = useData("services");
  const [active, setActive] = useState(null);
  const [cat, setCat] = useState("All");
  if (!data) return null;

  let items = data.items;
  if (cat !== "All") items = items.filter((s) => s.category === cat);
  if (limit) items = items.slice(0, limit);

  return (
    <>
      {withFilter && (
        <Reveal className="mb-10 flex flex-wrap gap-2">
          {["All", ...data.categories].map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`service-filter-${c.toLowerCase().replace(/\s+|&/g, "-")}`}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-all ${cat === c ? "bg-brand-gradient text-white" : "glass text-slate-600 hover:text-slate-900"}`}
            >
              {c}
            </button>
          ))}
        </Reveal>
      )}

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
        {items.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.08}>
            <TiltCard className="group h-full cursor-pointer p-6" onClick={() => setActive(s)} data-testid={`service-card-${s.id}`}>
              <div className="flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-soft text-brand transition-all duration-300">
                  <Icon name={s.icon} size={22} />
                </div>
                <ArrowUpRight className="text-slate-300 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-brand" size={20} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-500">{s.short}</p>
              <div className="mt-4 flex items-center gap-2">
                <span className="rounded-full bg-brand-soft px-2.5 py-1 text-[11px] font-medium text-brand-2">{s.category}</span>
                <span className="text-xs font-semibold text-brand">{s.priceRef}</span>
              </div>
            </TiltCard>
          </Reveal>
        ))}
      </div>

      <ServiceModal service={active} onClose={() => setActive(null)} />
    </>
  );
}
